module.exports = __webpack_public_path__ + "img/button_bg2.48856f27.png";